const WATCH_PAGE_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'm.youtube.com',
  'youtu.be',
  'instagram.com',
  'www.instagram.com',
  'twitch.tv',
  'www.twitch.tv',
  'drive.google.com',
  'tiktok.com',
  'www.tiktok.com',
  'vimeo.com',
  'www.vimeo.com',
]);

type OriginalVideoDownloadSources = {
  originalVideoUrl?: string | null;
  cutVideoUrl?: string | null;
  baseVideoUrl?: string | null;
  compressedBaseVideoUrl?: string | null;
};

export function isStoredOriginalVideoUrl(url?: string | null): url is string {
  if (!url) return false;

  try {
    const host = new URL(url, 'https://storage.autoclipper.live').hostname.toLowerCase();
    return !WATCH_PAGE_HOSTS.has(host);
  } catch {
    return false;
  }
}

/**
 * Community `base_video_url` is the watch-page URL used for remix.
 * The stored file lives on `original_video_url` (backend), then the
 * editor-compatible `cut_video_url` / `base_video_url` / compressed copy.
 */
export function resolveOriginalVideoDownloadUrl({
  originalVideoUrl,
  cutVideoUrl,
  baseVideoUrl,
  compressedBaseVideoUrl,
}: OriginalVideoDownloadSources): string | null {
  for (const url of [originalVideoUrl, cutVideoUrl, baseVideoUrl, compressedBaseVideoUrl]) {
    if (isStoredOriginalVideoUrl(url)) return url;
  }
  return null;
}
